import { LocalizedText } from "../i18n/LocalizedCopy";
import { useSourceLanguage } from "../i18n/LocalizedCopy";
import { useI18n } from "../i18n/LanguageContext";
import React from "react";
import EternuaProjectCards from "../crowdfunding/EternuaProjectCards";
import content from "./promotionContent.json";
import DeferredYouTubePlayer from "../media/DeferredYouTubePlayer";
import "./Lia3024Banner.css";

export default function Lia3024Banner() {
  useSourceLanguage();
  const { t } = useI18n();
  return (
    <section className="lia3024-banner" aria-labelledby="lia3024-promotion-title">
      <div className="lia3024-banner__copy">
        <p className="lia3024-banner__eyebrow"><span aria-hidden="true" /> {<LocalizedText source={t("lia.eyebrow", "LIA3024 · LE LABORATOIRE")} />}</p>
        <h2 id="lia3024-promotion-title">{<LocalizedText source={t("lia.title", content.title)} />}</h2>
        <p className="lia3024-banner__description">{<LocalizedText source={t("lia.description", content.text)} />}</p>
        <a className="lia3024-banner__button lia3024-banner__donate" href="/crowdfunding/projets/6c28e07e-be48-549c-b518-74911e748497">{<LocalizedText source={t("lia.support", "Soutenir LIA3024 / Faire un don ↗")} />}</a>
        <a className="lia3024-banner__button" href={content.href}>{<LocalizedText source={t("lia.discover", content.button)} />}<span aria-hidden="true">↗</span></a>
        <a className="lia3024-banner__support" href="/soutenir-eternua">{<LocalizedText source={t("lia.projects", "Voir les quatre projets Eternua ↗")} />}</a>
        <p className="lia3024-banner__notice">{<LocalizedText source={t("lia.notice", content.notice)} />}</p>
      </div>
      <a className="lia3024-banner__song" href={content.songHref} target="_blank" rel="noopener noreferrer" aria-label={t("lia.song.aria", "Écouter Elle a lu ma chanson sur YouTube (nouvel onglet)")}>
        <picture><source type="image/webp" srcSet="/lia3024/elle-a-lu-ma-chanson-480.webp 480w, /lia3024/elle-a-lu-ma-chanson.webp 1078w" sizes="(max-width: 768px) 90vw, 400px" /><img src={content.songImage} alt={t("lia.song.alt", content.songAlt)} width="1078" height="1086" decoding="async" fetchPriority="high" /></picture>
        <span className="lia3024-banner__song-label"><span aria-hidden="true">▶</span>{<LocalizedText source={t("lia.song.label", content.songLabel)} />}<span aria-hidden="true">↗</span></span>
      </a>
      <EternuaProjectCards illustratedOnly title={t("lia.cards", "LIA3024 et le robot envisagé")} />
      <div className="lia3024-banner__player">
        <h3>{<LocalizedText source={t("lia.playlist", "Écouter la playlist LIA3024")} />}</h3>
        <DeferredYouTubePlayer src={content.playlistEmbed} title={t("lia.player", "Lecteur YouTube — playlist LIA3024")} />
      </div>
    </section>
  );
}
